import type { StoryNode } from '@/engine/types'
import { cgPath } from '../cgAssets'

// 所有路线最终汇入同一个可终止节点；结算与收藏已在各路线的 ending 节点写入。
export const sharedNodes = [
  {
    id: 'credits-first-season',
    chapter: 'epilogue',
    actLabel: '事件一 · 完',
    date: '2026-07-28',
    title: '先上号，再说',
    location: '4945区 · 仍在运行',
    mode: 'ending',
    speaker: 'narrator',
    text: '固定的日期已经过去，你留下的局部改写仍在成员列表、群公告与私聊里继续生效。这里没有唯一真结局：历史节点提供压力，选择决定你怎样承担它。\n\n本作依据4945区玩家整理资料改编；现实记录与虚构演绎共同构成事件一，故事将在事件二继续。',
    background: 'ending',
    music: 'afterOnline',
    presentation: {
      cg: cgPath('cg41-season1-finale'),
      cgAlt: '7月28日清晨，六个组织空间围绕河流与要塞共同亮在4945区城市中，玩家手机仍有未读消息',
      ui: 'ending',
      transition: 'crossfade',
      camera: 'pull-back',
      atmosphere: 'petals',
      focus: 'center',
    },
    onEnter: [{ type: 'unlockCg', id: 'cg41-season1-finale' }],
  },

  // ──────────────── 事件一特殊结局网关 ────────────────
  // 组织结局先完成并落入收藏，再由此网关追加共享隐藏/世界线结局，最后统一进入事件一片尾。
  {
    id: 'worldline-check',
    chapter: 'epilogue',
    actLabel: '',
    date: '2026-07-28',
    mode: 'system',
    speaker: 'system',
    text: '...',
    background: 'ending',
    presentation: { hideDialogue: true, transition: 'cut', camera: 'hold', atmosphere: 'none', focus: 'center' },
    next: {
      cases: [
        { when: { type: 'flag', key: 'bf_anarchy' }, next: 'ending-chaos-collapse' },
        { when: { type: 'flag', key: 'bf_shadow_master' }, next: 'ending-shadow-puppet' },
        { when: { type: 'flag', key: 'wl_aberration' }, next: 'ending-aberration-diverge' },
        { when: { type: 'flag', key: 'wl_divergence' }, next: 'ending-aberration-converge' },
      ],
      fallback: 'credits-first-season',
    },
  },

  // ──────────────── 蝴蝶效应 · 共享隐藏结局 ────────────────
  {
    id: 'ending-chaos-collapse',
    chapter: 'epilogue',
    actLabel: '隐藏 · 崩坏',
    date: '2026-07-28',
    title: '崩坏',
    location: '？？？',
    mode: 'ending',
    speaker: 'narrator',
    text: '群公告变成乱码。排行榜的数字开始跳动，没有人确定那是涨还是跌。每条私信都在撤回，每个群都在改公告；没有人承认最先说了那句"随便吧"。\n\n最终，区服公告不出意外地变成了问号。你仍能登录，只是每次刷新都会看到不同的群名、不同的排名，以及上次登录时间——它永远停在昨天。',
    background: 'ending',
    music: 'afterOnline',
    presentation: {
      cg: cgPath('cg41-season1-finale'),
      cgAlt: '4945区的地图仍在，但所有标签都变成了问号，群聊名字如雪花般刷新',
      ui: 'ending-chaos',
      transition: 'glitch',
      camera: 'hold',
      atmosphere: 'danmaku',
      focus: 'center',
    },
    onEnter: [
      { type: 'unlockEnding', id: 'chaos-collapse' },
      { type: 'unlockCg', id: 'cg41-season1-finale' },
    ],
    next: 'credits-first-season',
  },
  {
    id: 'ending-shadow-puppet',
    chapter: 'epilogue',
    actLabel: '隐藏 · 提线木偶',
    date: '2026-07-28',
    title: '提线木偶',
    location: '？？？',
    mode: 'ending',
    speaker: 'narrator',
    text: '你回头清点自己每一次"主动选择"：原来从第一句私聊开始，对方就把选项写在了你够得着的地方。你没有被迫——你只是从没意识到，所有选项的结局都通向同一个方向。\n\n区服仍然运转。成员感谢你的决定，敌人按你预测的方式应对。一切都很合理，合理到你不确定自己还剩下什么选择没有做过。',
    background: 'ending',
    music: 'afterOnline',
    presentation: {
      cg: cgPath('cg41-season1-finale'),
      cgAlt: '三个相同的背影站在4945区地图前，每一条可见的路径最终都汇入同一处阴影',
      ui: 'ending-secret',
      transition: 'crossfade',
      camera: 'pull-back',
      atmosphere: 'none',
      focus: 'center',
    },
    onEnter: [
      { type: 'unlockEnding', id: 'shadow-puppet' },
      { type: 'unlockCg', id: 'cg41-season1-finale' },
    ],
    next: 'credits-first-season',
  },

  // ──────────────── 世界线异变 · 共享隐藏结局 ────────────────
  {
    id: 'ending-aberration-converge',
    chapter: 'epilogue',
    actLabel: '隐藏 · 世界线收束',
    date: '2026-07-28',
    title: '收束',
    location: '？？？',
    mode: 'ending',
    speaker: 'narrator',
    text: '你反复读档，每次选择都偏一点角度。冷酷、忠诚、混乱、外交、暗面、真心——六个维度的指针来回摇摆过，最终指向同一个日期。\n\n7月28日。你已无法确定自己是第几次看见这个清晨。所有分支的尽头都是同一张公告，所有人的结局都能从你最早的聊天记录里找到伏笔。世界线没有因为你的选择分叉——它们只是绕了一圈，又在原地汇合。',
    background: 'ending',
    music: 'afterOnline',
    presentation: {
      cg: cgPath('cg41-season1-finale'),
      cgAlt: '六条不同颜色的线从4945区地图各点同时汇入同一个终点标记',
      ui: 'ending-secret',
      transition: 'crossfade',
      camera: 'hold',
      atmosphere: 'none',
      focus: 'center',
    },
    onEnter: [
      { type: 'unlockEnding', id: 'aberration-converge' },
      { type: 'unlockCg', id: 'cg41-season1-finale' },
    ],
    next: 'credits-first-season',
  },
  {
    id: 'ending-aberration-diverge',
    chapter: 'epilogue',
    actLabel: '隐藏 · 世界线发散',
    date: '2026-07-28',
    title: '发散',
    location: '？？？',
    mode: 'ending',
    speaker: 'narrator',
    text: '屏幕裂成六块，每一块里都有一个你，在同一天的不同群聊中说出完全不同的话。其中一个选择了冷酷，另一个选择了忠诚，第三个把外交用到了极限，第四个在暗面与真心之间反复横跳。\n\n你无法同时阅读所有窗口，但你能感觉到：每条世界线里的4945区都在继续运转。区别只是——这一次，你知道了所有你没有选的路。',
    background: 'ending',
    music: 'afterOnline',
    presentation: {
      cg: cgPath('cg41-season1-finale'),
      cgAlt: '同一张4945区地图被六条不同颜色的分支同时折叠展开，每一条都真实发生过',
      ui: 'ending-chaos',
      transition: 'glitch',
      camera: 'pull-back',
      atmosphere: 'danmaku',
      focus: 'center',
    },
    onEnter: [
      { type: 'unlockEnding', id: 'aberration-diverge' },
      { type: 'unlockCg', id: 'cg41-season1-finale' },
    ],
    next: 'credits-first-season',
  },
] satisfies StoryNode[]
